import { GiveawayStep } from '../../constants/giveaway.constants';
export const isGiveawaySuspended = step => {
  return step === GiveawayStep.suspended;
};